/* Currency picker (sections/rg-currency.liquid). Offers ~135 currencies like krypt's picker.
   - Currencies the store really sells in (Settings > Markets: AED, QAR, SAR, USD, CAD, AUD, NZD, SGD) switch the
     whole store through Shopify's localization form, so checkout is in that currency.
   - Every other currency is DISPLAY ONLY: the store is in AED, so "Dhs. 140.00" texts are shown converted
     (rates: open.er-api.com, cached 12 h, with a built-in snapshot) and checkout stays in AED.
   No dependencies. */
(function () {
  var root = document.querySelector('[data-rg-cur]');
  if (!root || root.dataset.rgReady) return;
  root.dataset.rgReady = '1';

  // AED -> currency snapshot, 2026-10-12 (replaced by live rates when they load)
  var RATES = { USD: 0.272294, EUR: 0.243754, GBP: 0.206028, CAD: 0.388669, ALL: 22.302967, AFN: 17.678586, AMD: 98.625334, AOA: 252.78121, ARS: 412.764221, AUD: 0.39114, AWG: 0.487406, AZN: 0.462842, BIF: 817.182532, BBD: 0.544588, BDT: 33.540662, BSD: 0.272294, BHD: 0.102383, BMD: 0.272294, BYN: 0.820106, BZD: 0.544588, BTN: 26.11664, BAM: 0.476739, BRL: 1.358723, BOB: 3.224549, BWP: 3.805048, BND: 0.348752, BGN: 0.476739, CDF: 629.581535, CHF: 0.227113, CLP: 266.040474, CNY: 1.825955, COP: 870.824094, CRC: 123.976411, CZK: 5.944, DJF: 48.392376, DKK: 1.820653, DOP: 16.575366, DZD: 36.659241, EGP: 14.337107, ETB: 43.96899, FJD: 0.612228, FKP: 0.205971, GIP: 0.205971, GHS: 3.205667, GMD: 20.302187, GNF: 2396.321047, GTQ: 2.081625, GEL: 0.706987, HNL: 7.308049, HKD: 2.136912, HTG: 35.64962, HUF: 88.990668, IDR: 4880.302009, ILS: 0.837827, ISK: 33.241612, INR: 26.11684, IQD: 410.681018, IRR: 467882.353404, JMD: 43.289273, JPY: 43.172598, JOD: 0.193057, KES: 35.313936, KGS: 23.817294, KHR: 1103.885886, KMF: 119.91859, KRW: 363.149128, KWD: 0.084688, KYD: 0.226912, KZT: 122.718632, LBP: 24370.319946, LKR: 90.069, LRD: 46.510048, LSL: 4.504759, LYD: 1.748955, MAD: 2.644267, MDL: 4.866426, MGA: 1232.445137, MMK: 571.429303, MKD: 14.860072, MOP: 2.201019, MUR: 12.935748, MVR: 4.204753, MWK: 474.385703, MXN: 4.980989, MYR: 1.111868, MZN: 17.35157, NAD: 4.504759, NPR: 41.786625, NZD: 0.487031, NIO: 10.018374, NOK: 2.607152, OMR: 0.104696, PAB: 0.272294, PKR: 75.388563, PGK: 1.200042, PEN: 0.935197, PHP: 17.102184, PLN: 1.069191, QAR: 0.99115, RON: 1.299572, RUB: 22.881685, RWF: 402.382773, SAR: 1.021103, RSD: 28.573158, SCR: 3.936856, SGD: 0.348752, SYP: 33.142255, SEK: 2.732078, TWD: 8.702665, THB: 9.153854, TZS: 717.051893, TTD: 1.847685, TND: 0.818783, TRY: 13.4376, SBD: 2.174203, SDG: 123.685375, SLL: 6695.080149, SRD: 10.251698, SZL: 4.504759, TJS: 2.51369, TOP: 0.651401, TMT: 0.952969, UAH: 12.243887, UGX: 1090.504983, UYU: 10.95189, UZS: 3236.775874, VND: 7050.327369, VUV: 32.52771, WST: 0.74868, XAF: 159.891453, XPF: 29.087527, YER: 64.304463, ZAR: 4.504759 };
  var NATIVE = {}, KEY = 'rg-display-currency', RKEY = 'rg-rates';
  try { NATIVE = JSON.parse(root.getAttribute('data-native') || '{}'); } catch (e) {}
  if (NATIVE.AED) NATIVE.AED = 'AE'; // the GCC market lists Bahrain first for AED; switching back should mean the UAE
  var active = root.getAttribute('data-active') || 'AED'; // currency Shopify is currently using
  var display = '';
  try { display = localStorage.getItem(KEY) || ''; } catch (e) {}
  if (active !== 'AED' || !RATES[display]) display = ''; // display-only conversion works from AED only

  var btn = root.querySelector('[data-rg-cur-btn]'), label = btn.querySelector('[data-label]');
  var panel = root.querySelector('.rg-cur__panel'), list = root.querySelector('.rg-cur__menu');
  var search = root.querySelector('.rg-cur__search'), status = root.querySelector('.rg-cur__status');
  var form = root.querySelector('form'), field = form && form.querySelector('[name="country_code"]');

  var names;
  try { names = new Intl.DisplayNames(['en'], { type: 'currency' }); } catch (e) { names = null; }
  function nameOf(code) { try { return (names && names.of(code)) || code; } catch (e) { return code; } }

  /* ---------- price conversion ---------- */
  var RE = /Dhs\.?\s*(-?[\d,]+(?:\.\d+)?)(\s*AED)?/g, orig = new WeakMap(), outs = new WeakMap();
  function fmt(v) {
    try { return new Intl.NumberFormat('en', { style: 'currency', currency: display }).format(v); }
    catch (e) { return display + ' ' + v.toFixed(2); }
  }
  function convert(node) {
    var o = orig.get(node);
    if (o === undefined) {
      if (!/Dhs\.?\s*\d/.test(node.nodeValue)) return;
      o = node.nodeValue; orig.set(node, o);
    }
    var out = display ? o.replace(RE, function (m, num) { return fmt(parseFloat(num.replace(/,/g, '')) * RATES[display]); }) : o;
    if (node.nodeValue !== out) { outs.set(node, out); node.nodeValue = out; }
  }
  function walk(el) {
    if (!el || el.nodeType === 8) return;
    if (el.nodeType === 3) { convert(el); return; }
    if (el.nodeType !== 1 || /^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA|INPUT|SELECT|OPTION)$/.test(el.tagName) || el.closest('[data-rg-cur]')) return;
    var tw = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null), n;
    while ((n = tw.nextNode())) {
      var p = n.parentNode;
      if (p && /^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA)$/.test(p.tagName)) continue;
      convert(n);
    }
  }
  var queue = [], scheduled = false;
  function flush() { scheduled = false; var q = queue; queue = []; q.forEach(walk); }
  function enqueue(n) { queue.push(n); if (!scheduled) { scheduled = true; requestAnimationFrame(flush); } }
  new MutationObserver(function (records) {
    if (!display && !document.documentElement.hasAttribute('data-rg-converted')) return;
    records.forEach(function (r) {
      if (r.type === 'characterData') { if (r.target.nodeValue !== outs.get(r.target)) { orig.delete(r.target); enqueue(r.target); } }
      else r.addedNodes.forEach(enqueue);
    });
  }).observe(document.body, { childList: true, subtree: true, characterData: true });

  function apply() {
    if (display) document.documentElement.setAttribute('data-rg-converted', '');
    walk(document.body);
    label.textContent = display || active;
    document.documentElement.toggleAttribute('data-rg-converted', !!display);
  }

  // Live rates (cached 12 h); the snapshot above is used until they arrive or if the request fails
  try {
    var cached = JSON.parse(localStorage.getItem(RKEY) || 'null');
    if (cached && Date.now() - cached.t < 432e5) Object.assign(RATES, cached.r);
    else if (display) {
      fetch('https://open.er-api.com/v6/latest/AED').then(function (r) { return r.json(); }).then(function (j) {
        if (j && j.rates) { Object.keys(RATES).forEach(function (c) { if (j.rates[c]) RATES[c] = j.rates[c]; }); try { localStorage.setItem(RKEY, JSON.stringify({ t: Date.now(), r: RATES })); } catch (e) {} apply(); }
      }).catch(function () {});
    }
  } catch (e) {}

  /* ---------- picker ---------- */
  var codes = ['AED'].concat(Object.keys(RATES)).filter(function (c, i, a) { return a.indexOf(c) === i; });
  codes.sort(function (a, b) { var na = NATIVE[a] ? 0 : 1, nb = NATIVE[b] ? 0 : 1; return na - nb || (a === 'AED' ? -1 : b === 'AED' ? 1 : a < b ? -1 : 1); });
  list.innerHTML = codes.map(function (c) {
    return '<li role="none"><button type="button" role="option" class="rg-cur__opt" data-code="' + c + '" data-name="' + nameOf(c).toLowerCase() + '"><b>' + c + '</b><span>' + nameOf(c) + '</span>' +
      (NATIVE[c] ? '<i>pay in ' + c + '</i>' : '') + '</button></li>';
  }).join('');

  function mark() {
    var cur = display || active;
    Array.prototype.forEach.call(list.querySelectorAll('.rg-cur__opt'), function (b) {
      var on = b.getAttribute('data-code') === cur;
      b.classList.toggle('is-on', on); b.setAttribute('aria-selected', on);
    });
  }
  function setOpen(open) {
    panel.hidden = !open; btn.setAttribute('aria-expanded', open); root.classList.toggle('is-open', open);
    if (open) { mark(); search.value = ''; filter(); search.focus(); }
  }
  function filter() {
    var q = search.value.trim().toLowerCase();
    Array.prototype.forEach.call(list.children, function (li) {
      var b = li.firstChild;
      li.hidden = !!q && b.getAttribute('data-code').toLowerCase().indexOf(q) < 0 && b.getAttribute('data-name').indexOf(q) < 0;
    });
  }
  function submitNative(code) { if (!form || !field || !NATIVE[code]) return false; field.value = NATIVE[code]; form.submit(); return true; }
  function choose(code) {
    try { localStorage.setItem(KEY, NATIVE[code] ? '' : code); } catch (e) {}
    if (NATIVE[code]) {
      display = '';
      if (code !== active) { submitNative(code); return; }
    } else {
      display = code;
      if (active !== 'AED') { submitNative('AED'); return; } // switch back to AED first, the conversion applies after the reload
    }
    apply(); setOpen(false); btn.focus();
    status.textContent = display ? 'Prices shown in ' + display + '. You pay in AED at checkout.' : 'Prices shown in ' + active + '.';
  }

  btn.addEventListener('click', function () { setOpen(panel.hidden); });
  search.addEventListener('input', filter);
  list.addEventListener('click', function (e) { var b = e.target.closest('.rg-cur__opt'); if (b) choose(b.getAttribute('data-code')); });
  function visibleOpts() { return Array.prototype.filter.call(list.querySelectorAll('.rg-cur__opt'), function (b) { return !b.parentNode.hidden; }); }
  panel.addEventListener('keydown', function (e) {
    var opts = visibleOpts(), i = opts.indexOf(document.activeElement);
    if (e.key === 'ArrowDown') { e.preventDefault(); (opts[i + 1] || opts[0] || search).focus(); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); if (i <= 0) search.focus(); else opts[i - 1].focus(); }
    else if (e.key === 'Enter' && document.activeElement === search && opts[0]) { e.preventDefault(); choose(opts[0].getAttribute('data-code')); }
  });
  document.addEventListener('pointerdown', function (e) { if (!root.contains(e.target)) setOpen(false); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) { setOpen(false); btn.focus(); } });

  // Shopify's preview bar sits over the bottom edge of the draft preview: lift the pill (and back-to-top) above it
  function lift() { document.documentElement.classList.toggle('rg-has-pbar', !!document.getElementById('PBarNextFrame')); }
  lift(); new MutationObserver(lift).observe(document.body, { childList: true });

  apply();
})();